(function () {
  /**
   * @ngdoc module
   * @name binky.core.offers.fulfillable-items
   * @description Module which defines fulfillable item constants
   */
  angular.module('binky.core.offers.fulfillable-items', []);
})();
